import React, { useState, useEffect } from 'react';
import { useTheme } from '../hooks/useTheme';
import { getLeaderboard } from '../services/firestore';

const Leaderboard = () => {
    const { darkMode } = useTheme();
    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLeaderboard = async () => {
            try {
                const leaderboardData = await getLeaderboard();
                setLeaderboard(leaderboardData);
            } catch (error) {
                console.error('Error fetching leaderboard:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchLeaderboard();
    }, []);

    if (loading) {
        return (
            <div className="max-w-4xl mx-auto px-4 py-8">
                <h2 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'} mb-6`}>🏆 Leaderboard</h2>
                <div className={`text-center ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Loading...</div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto px-4 py-8">
            <h2 className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'} mb-6`}>🏆 Leaderboard</h2>
            {leaderboard.length > 0 ? (
                <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow overflow-hidden`}>
                    <div className={`divide-y ${darkMode ? 'divide-gray-700' : 'divide-gray-200'}`}>
                        {leaderboard.map((user, index) => (
                            <div key={user.id} className="p-6">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0">
                                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-bold ${index === 0 ? 'bg-yellow-500' :
                                                    index === 1 ? 'bg-gray-400' :
                                                        index === 2 ? 'bg-orange-600' : 'bg-blue-500'
                                                }`}>
                                                {index < 3 ? ['🥇', '🥈', '🥉'][index] : index + 1}
                                            </div>
                                        </div>
                                        <div className="ml-4">
                                            <div className="flex items-center gap-2">
                                                {user.photoURL && (
                                                    <img
                                                        src={user.photoURL}
                                                        alt={user.displayName || 'User'}
                                                        className="w-6 h-6 rounded-full object-cover"
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                        }}
                                                    />
                                                )}
                                                <p className={`text-sm font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                                                    {user.displayName || 'Anonymous User'}
                                                </p>
                                            </div>
                                            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                {user.totalWorkouts} workouts • {user.streak || 0} day streak
                                            </p>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <p className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{user.totalPoints}</p>
                                        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>points</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow p-6 text-center ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    <p>No users on the leaderboard yet. Be the first to add a workout! 🚀</p>
                </div>
            )}
        </div>
    );
};

export default Leaderboard;